// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Vg59mlHVoi349K {
  position: relative;
  min-width: 750px;
  max-width: 880px;
  margin: auto;
  border-radius: var(--ds-border-radius-300, 12px);
  background-color: var(--ds-surface, #ffffff);
}
.ltZGhqjCZV4Z1C {
  display: block;
  width: 100%;
  border-top-left-radius: var(--ds-border-radius-300, 10px);
  border-top-right-radius: var(--ds-border-radius-300, 10px);
}
.vEw29A96lgDDr9 {
  padding: var(--ds-space-400, 32px) 140px var(--ds-space-500, 40px) 140px;
  text-align: center;
}
.BsVSJ796Ffupm_ {
  display: flex;
  justify-content: center;
  margin-top: var(--ds-space-500, 40px);
  column-gap: var(--ds-space-100, 8px);
}
.BsCicG44_L4G4T {
  position: absolute;
  top: var(--ds-space-100, 8px);
  right: var(--ds-space-200, 16px);
  color: #ffffff;
}
.BsCicG44_L4G4T:hover,
.BsCicG44_L4G4T:active {
  color: #ffffff;
}
`, ""]);
// Exports
export var gaWelcomeModal = `Vg59mlHVoi349K`;
export var headingImage = `ltZGhqjCZV4Z1C`;
export var contentContainer = `vEw29A96lgDDr9`;
export var ctasContainer = `BsVSJ796Ffupm_`;
export var closeButton = `BsCicG44_L4G4T`;
export default ___CSS_LOADER_EXPORT___;
